import {
  EnvSection,
  EnvTopic,
} from '@/domain/impact-env/entities/question.entity';

export const envTourGeneralQuizLayout: Record<
  EnvTopic,
  {
    sections: Array<EnvSection>;
  }
> = {
  [EnvTopic.GLOBAL_CO2]: {
    sections: [],
  },
  [EnvTopic.EQUIPMENT_AND_SCENOGRAPHY]: {
    sections: [EnvSection.SCENOGRAPHY, EnvSection.TECHNIQUE],
  },
  [EnvTopic.FOOD_BEVERAGES]: {
    sections: [EnvSection.CATERING, EnvSection.DISHES],
  },
  [EnvTopic.RESOURCES_POLLUTION]: {
    sections: [EnvSection.WATER_AND_WASTE],
  },
  [EnvTopic.COMMUNICATION]: {
    sections: [
      EnvSection.PHYSICAL_COMMUNICATION,
      EnvSection.DIGITAL_COMMUNICATION,
    ],
  },
  [EnvTopic.PUBLIC_ENGAGEMENT]: {
    sections: [EnvSection.PARTNERSHIP_STRATEGY, EnvSection.PUBLIC_INFORMATION],
  },
};
